import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useTranslation } from '@/hooks/useTranslations';
export function OfferCardMostPopularLabel({ id, onSelect, isMobile, }) {
    const { t } = useTranslation();
    const handleSelectOffer = () => {
        if (onSelect && id) {
            onSelect(id);
        }
    };
    return (_jsx(Box, { as: "button", cursor: isMobile ? 'pointer' : 'default', onClick: handleSelectOffer, width: "100%", borderStyle: "none", testId: "offer-card-most-popular", height: "sizing.24", backgroundColor: "color.surface.brand.primary.default", typography: "typography.body.14.regular", textAlign: "center", alignContent: "center", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16", children: t('offerCard.mostPopularLabel') }));
}
